const backgroundOffsets = {
    1 : -150, // Origin 
    2 : -250, // Constants
    3 : -350, // Worlds
    4 : -475 // Theories
};

export default backgroundOffsets;